// Mirrors isLinkedInUrl: same shape, same messages, one host.
//
// The dot is escaped where LinkedIn's is not. An unescaped dot matches any
// character, so that regex also accepts linkedinXcom -- harmless in practice
// but not worth copying into a new file.
const INSTAGRAM_URL_REGEX = /^http(?:s)?:\/\/(?:www\.)?instagram\.com\//;

export const isInstagramUrl = (url: string) => {
  if (!url) return;
  try {
    // Parse the URL to ensure it is valid
    const parsedUrl = new URL(url);
    if (!parsedUrl.href.match(INSTAGRAM_URL_REGEX)) {
      return {
        message: "crm.validation.invalid_instagram_url",
        args: { _: "URL must be from instagram.com" },
      };
    }
  } catch {
    // If URL parsing fails, return false
    return {
      message: "crm.validation.invalid_url",
      args: { _: "Must be a valid URL" },
    };
  }
};
